"use client"
import Heading from '@/components/ui/Heading'
import { Accordion, AccordionItem } from '@nextui-org/react'
import Image from 'next/image'
import React from 'react'

const FAQs = () => {
    const faqs = [
        {
            title: 'How do I make Chai ?',
            content: "Take a full spoon from the pack and place it in a cup. Add 180ml/6fl oz of hot water, stirring thoroughly with a spoon. Alternatively, use a utensil to measure 180ml of water and optionally add 10-20 ml of your desired milk. Add a full spoon from the pack to the utensil and let it boil for 4-5 minutes. Pour the brewed chai into a cup and enjoy your delightful beverage."
        }, {
            title: 'What makes the taste of your chai so delicious ?',
            content: "When you choose to invest in our premium chai, you're not just acquiring a beverage; you're immersing yourself in a centuries-old tradition, savoring distinctive flavors, and possibly reaping some health benefits. Our spice-infused Chai strikes a harmonious balance between richness, warmth, and a subtle touch of spiciness, resulting in a delightful and comforting exploration of flavors. Your investment in premium chai promises a delightful and rewarding experience, backed by our 100% guarantee."
        }, {
            title: 'Where do you ship your Chai from ?',
            content: "Our fresh Premix is dispatched from our warehouse in the USA. Domestic shipping covers deliveries within the United States, including US territories such as Puerto Rico and the Virgin Islands."
        }, {
            title: 'What are the shipping charges?',
            content: "We offer flat shipping fee of $5.99 on all orders."
        }, {
            title: 'What is your return policy?',
            content: "We have a 30 day return policy for unopened product. please contact us."
        }, {
            title: 'How many cups does your 1.1lb box make ?',
            content: "Our 1.1lb box can produce as many as 40 cups of Chai, tailored to your liking."
        }
    ]

    return (
        <section className="w-[94%] max-w-[1440px] mx-auto flex flex-col justify-center items-center gap-8 py-8">
            <Heading text="Have a Question?" />
            <p className='text-xl mb-4'>We Would Love to Answer</p>
            <div className="flex w-full justify-center items-start gap-4 md:grid grid-cols-2 flex-col">
                <Image src={'/images/faq.png'} alt='woman with tea cup' width={720} height={720} className='w-full place-self-end md:max-w-[512px] object-top object-cover rounded-lg h-full' />
                <div className="grid grid-cols-1 w-full justify-center gap-4 items-center">
                    <Accordion variant="shadow">
                        {
                            faqs.map((faq, index) => (
                                <AccordionItem key={index} aria-label={faq.title} title={faq.title}>
                                    <p>{faq.content}</p>
                                </AccordionItem>
                            ))
                        }
                    </Accordion>
                </div>

            </div>
        </section >

    )
}

export default FAQs